module.exports = __webpack_public_path__ + "static/media/minus-button.2ba4cbf5.svg";